import { FigureCaption } from "shared/components/FigureCaption";
import { TINY, SMALL, MEDIUM, LARGE } from "shared/utils/constants";
import { MaxWidth } from "shared/components/MaxWidth";
import { SrcSet } from "shared/components/SrcSet";

export const ImageContainer = ({
  alt,
  caption,
  credits,
  src,
  size = SMALL,
}) => (
  <div className="ImageContainer">
    <MaxWidth size={size === TINY ? SMALL : size}>
      <Image
        alt={alt}
        caption={caption}
        credits={credits}
        src={src}
        size={size}
      />
    </MaxWidth>
  </div>
);

export const Image = ({ alt, caption, credits, size = SMALL, src }) => {
  const maxWidths = {
    [TINY]: 340,
    [SMALL]: 640,
    [MEDIUM]: 1000,
    [LARGE]: 1320,
  };

  const maxWidth = maxWidths[size];

  return (
    <FigureCaption caption={caption} credits={credits} half={size === TINY}>
      <SrcSet alt={alt} maxWidth={maxWidth} src={src} />
    </FigureCaption>
  );
};
